var _circle, _path, _path2, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSendBtn(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 41,
    viewBox: "0 0 41 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20.6719,
    cy: 20.75,
    r: 20,
    fill: "#8F4300"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0583 29.0826C22.0408 29.0826 22.0241 29.0817 22.0074 29.0809C21.6308 29.0584 21.3166 28.7851 21.2416 28.4151L19.9599 22.1092C19.8933 21.7809 19.6374 21.5251 19.3091 21.4584L13.0033 20.1759C12.6333 20.1017 12.3599 19.7876 12.3374 19.4109C12.3149 19.0334 12.5474 18.6884 12.9058 18.5701L26.2391 14.1259C26.5383 14.0242 26.8683 14.1026 27.0916 14.3267C27.3149 14.5501 27.3924 14.8801 27.2933 15.1792L22.8483 28.5126C22.7349 28.8551 22.4149 29.0826 22.0583 29.0826Z",
    fill: "#231F20"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_428_141598",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 12,
    y: 14,
    width: 16,
    height: 16
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0583 29.0826C22.0408 29.0826 22.0241 29.0817 22.0074 29.0809C21.6308 29.0584 21.3166 28.7851 21.2416 28.4151L19.9599 22.1092C19.8933 21.7809 19.6374 21.5251 19.3091 21.4584L13.0033 20.1759C12.6333 20.1017 12.3599 19.7876 12.3374 19.4109C12.3149 19.0334 12.5474 18.6884 12.9058 18.5701L26.2391 14.1259C26.5383 14.0242 26.8683 14.1026 27.0916 14.3267C27.3149 14.5501 27.3924 14.8801 27.2933 15.1792L22.8483 28.5126C22.7349 28.8551 22.4149 29.0826 22.0583 29.0826Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_428_141598)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 10.6719,
    y: 10.75,
    width: 20,
    height: 20,
    fill: "white"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBtn);
export default __webpack_public_path__ + "static/media/send_btn.7fa82f132d7775178778429579e6f974.svg";
export { ForwardRef as ReactComponent };